import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from 'mypage/src/constant/queryKey';
import { productCategoryService } from 'shared/src/api';

export const useProductCategoryMeasureValuesRenderInfo = (
  productCategorySno: number,
) => {
  return useSuspenseQuery({
    queryKey: queryKey.productCategoryMeasureValues(productCategorySno),
    queryFn: () =>
      productCategoryService.getProductCategoryMeasureValues(
        productCategorySno,
      ),
    staleTime: 0,
    select: data => ({
      measureValues: data.measure_values.reduce(
        (acc, cur) => {
          if (cur.spot_sno == null) return acc;
          acc[cur.spot_sno] = cur.value;
          return acc;
        },
        {} as Record<number, number | null>,
      ),
      hasAnyValue: data.measure_values.some(
        v => v.value != null && v.value > 0,
      ),
    }),
  });
};
